'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# ConnectSVG
An SVG Connect icon
 */
var ConnectSVG = function ConnectSVG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 20 20',
      'aria-label': 'Connect',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      x: '0px',
      y: '0px'
    },
    _react2.default.createElement('path', {
      fill: color,
      d: 'M13,6.5c0-0.2,0-0.9-0.4-1.7c-0.2-0.5-0.5-0.9-0.9-1.2c-0.1-0.1-0.2-0.1-0.3-0.2C11.8,3,12,2.5,12,2\r c0-1.1-0.9-2-2-2S8,0.9,8,2c0,0.5,0.2,1,0.5,1.4C8.4,3.4,8.3,3.5,8.2,3.6C7.9,3.9,7.6,4.3,7.4,4.8C7,5.6,7,6.5,7,6.5\r C7,6.8,7.2,7,7.5,7h5c0,0,0,0,0,0C12.8,7,13,6.8,13,6.5C13,6.5,13,6.5,13,6.5z M9,2c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S9,2.6,9,2\r z M8.1,6c0-0.2,0.1-0.5,0.2-0.8C8.6,4.4,9.2,4,10,4c1.4,0,1.8,1.3,2,2H8.1L8.1,6z'
    }),
    _react2.default.createElement('path', {
      fill: color,
      d: 'M6,17.5c0-0.2,0-0.9-0.4-1.7c-0.2-0.5-0.5-0.9-0.9-1.2c-0.1-0.1-0.2-0.1-0.3-0.2C4.8,14,5,13.5,5,13\r c0-1.1-0.9-2-2-2s-2,0.9-2,2c0,0.5,0.2,1,0.5,1.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.4,0.3-0.7,0.7-0.9,1.2C0,16.6,0,17.5,0,17.5\r C0,17.8,0.2,18,0.5,18h5c0,0,0,0,0,0C5.8,18,6,17.8,6,17.5C6,17.5,6,17.5,6,17.5z M2,13c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1\r S2,13.6,2,13z M1,17c0-0.2,0.1-0.5,0.2-0.8C1.6,15.4,2.2,15,3,15c1.4,0,1.8,1.3,2,2H1L1,17z'
    }),
    _react2.default.createElement('path', {
      fill: color,
      d: 'M20,17.5c0-0.2,0-0.9-0.4-1.7c-0.2-0.5-0.5-0.9-0.9-1.2c-0.1-0.1-0.2-0.1-0.3-0.2C18.8,14,19,13.5,19,13\r c0-1.1-0.9-2-2-2s-2,0.9-2,2c0,0.5,0.2,1,0.5,1.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.4,0.3-0.7,0.7-0.9,1.2C14,16.6,14,17.5,14,17.5\r c0,0.3,0.2,0.5,0.5,0.5h5c0,0,0,0,0,0C19.8,18,20,17.8,20,17.5C20,17.5,20,17.5,20,17.5z M16,13c0-0.6,0.4-1,1-1s1,0.4,1,1\r s-0.4,1-1,1S16,13.6,16,13z M15.1,17c0-0.2,0.1-0.5,0.2-0.8c0.3-0.8,0.9-1.2,1.7-1.2c1.4,0,1.8,1.3,2,2H15.1L15.1,17z'
    }),
    _react2.default.createElement('path', {
      fill: color,
      d: 'M10,20c-1.3,0-2.6-0.3-3.7-0.9c-0.2-0.1-0.3-0.4-0.2-0.7s0.4-0.3,0.7-0.2c1,0.5,2.1,0.8,3.3,0.8\r s2.3-0.3,3.3-0.8c0.2-0.1,0.5,0,0.7,0.2s0,0.5-0.2,0.7C12.6,19.7,11.3,20,10,20z'
    }),
    _react2.default.createElement('path', {
      fill: color,
      d: 'M17.2,10.5c-0.2,0-0.4-0.1-0.5-0.4c-0.5-1.7-1.5-3.1-3-4.1c-0.2-0.1-0.3-0.5-0.2-0.7s0.5-0.3,0.7-0.2\r c1.7,1.1,2.9,2.7,3.4,4.6c0.1,0.3-0.1,0.5-0.3,0.6C17.3,10.5,17.3,10.5,17.2,10.5L17.2,10.5z'
    }),
    _react2.default.createElement('path', {
      fill: color,
      d: 'M2.8,10.5c0,0-0.1,0-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6C2.8,7.9,4,6.3,5.7,5.2C6,5.1,6.3,5.2,6.4,5.4\r s0.1,0.5-0.2,0.7c-1.5,0.9-2.6,2.4-3,4.1C3.2,10.4,3,10.5,2.8,10.5L2.8,10.5z'
    })
  );
};

ConnectSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  /** a color for the icon */
  color: _propTypes2.default.string
};

ConnectSVG.displayName = 'ConnectSVG';

exports.default = ConnectSVG;
ConnectSVG.__docgenInfo = {
  'description': '# ConnectSVG\r\nAn SVG Connect icon',
  'methods': [],
  'displayName': 'ConnectSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    }
  }
};